import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import frResources from './locales/fr'

/**
 * i18n configuration for SuperAdmin Frontend
 * French only
 */
i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frResources },
    },
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // React already handles XSS
    },
  })

export default i18n

